<div [attr.data-testid]="dataTestId">
  <label
    *ngIf="label"
    class="o-form-label"
    [ngClass]="{'pseic-form-field-label-invalid': controlName?.errors && (controlName?.touched || controlName?.dirty)}"
    [for]="labelFor || controlName?.name"
  >{{label}}
    <span
      *ngIf="isRequiredAsterisk"
      class="pseic-form-field-label-required-asterisk"
    >*</span>
  </label>
  <div
    [ngClass]="{'content-row': !label && isRequiredAsterisk && showRequiredAsteriskWithoutLabel}"
  >
    <ng-content></ng-content>
    <div *ngIf="!label && isRequiredAsterisk && showRequiredAsteriskWithoutLabel" class="pseic-form-field-label-required-asterisk"
         [ngClass]="{'pseic-form-field-required-asterisk-no-label': showRequiredAsteriskWithoutLabel}"
    >*</div>
  </div>
  <pseic-form-field-errors [control]="controlName?.control"
                           [resizeOnError]="resizeOnError"
                           [dataTestId]="dataTestId + '-error'"
  ></pseic-form-field-errors>
</div>
